export default __webpack_public_path__ + "static/media/questionsets_sel.b693201d.svg";